import Vue from 'vue'
import Router from 'vue-router'
import routes from './common/config/router.js'

import i18n from './plugins/i18n.js' // 引入 i18n

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

let router = new Router({routes})


//全局前置守卫
router.beforeEach((to,from,next)=>{
	document.title = i18n.t('system.title')
	let token = window.sessionStorage.getItem('token')
	let user = window.sessionStorage.getItem('user')
	if(token){
		if(to.path ==='/login'){
			Vue.prototype.$message.error(i18n.t('message.notLogInAgain'))
			return next({name:from.name?from.name:'index'});
		}
		if(to.name!=='error_404'){
			
			//超級管理员跳过验证
			if(user){
				user = JSON.parse(user)
				if(user.type === 1){
					return next()
				}
			}
			// 其他验证
			let rules = window.sessionStorage.getItem('rules')
			rules = rules?JSON.parse(rules):[]
			
			let index = rules.findIndex(item=>{
				return item.rule_id>0 && item.desc===to.name
			})
			
			if(index === -1){
				Vue.prototype.$message.error(i18n.t('message.noPower'))
				return next({name:from.name?from.name:'error_404'});
			}
		}
	
		// 已登錄
		next();
	}else{
		//跳过验证
		if(to.path ==='/login'){
			return next();
		}
		//未登錄
		// Vue.prototype.$message.error(i18n.t('message.noLogin'))
		next({path:'/login'})
	}
})

export default router